import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import clsx from "clsx";
import BlockButton from "components/UI/BlockButton";
import config from "config/api";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/core/styles";
// import LoginForm from 'components/Forms/LoginForm';
// import RegistrationForm from "components/Forms/RegistrationTwoStepsForm";
import RegistrationForm from "components/Forms/LoginForm";
import DialogPopinButton from "components/UI/Dialog/DialogPopinButton";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import IconArrow from "@material-ui/icons/ArrowDropDown";
import { headerBgColor } from "../../helpers/colors";
import Box from "@material-ui/core/Box";
import "react-sticky-header/styles.css";
import HeaderMenu from "./HeaderMenu";
import RGPDBanner from "components/UI/RGPDBanner/RGPDBanner";

import { fetchData } from "../../ducks/asyncFetcher";

import {
  isLoggedIn,
  getCurrentUserRole,
  getCurrentUserSubRole,
  getCurrentUser,
} from "ducks/authentication";

const AF_KEY = "home";

const styles = (theme) => {
  const root = {
    width: "100%",
    padding: "40px 20px 0",
    backgroundColor: headerBgColor || "transparent",
    "& .MuiButton-root.right": {
      paddingLeft: 20,
      paddingRight: 20,
      [theme.breakpoints.down("sm")]: {
        // marginTop: 10,
        // marginBottom: 20
        display: "block",
        margin: "auto",
      },
    },
  };

  if (!headerBgColor) {
    root.backgroundRepeat = "no-repeat";
    root.backgroundPosition = "50% 0";
    root.backgroundSize = "contain";
    root.backgroundImage =
      "url(" +
      require("assets/images/" + process.env.REACT_APP_SITE + "/header.jpg") +
      ")";
  }

  return {
    root,
    header: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "50% 50%",
      "& .MuiTypography-h1": {
        // border: "1px " + theme.palette.primary.main + " solid",
        border: "none",
      },
    },
    wrapper: {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column-reverse",
      },
    },
    logo: {
      cursor: "pointer",
      backgroundImage: `url(${require("assets/images/" +
        process.env.REACT_APP_SITE +
        "/logo.png")})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      width: "107px",
      height: "47px",
      display: "block",
      margin: "0 0 10px auto",
      [theme.breakpoints.down("sm")]: {
        margin: "10px auto 20px auto",
        backgroundPosition: "center",
      },
    },
    profileWrapper: {
      padding: 0,
      minWidth: 200,
      // marginTop: "-40px",
      borderRadius: "0 0 4px 4px",
      backgroundColor: theme.palette.background.default,
      border: "1px #fff solid",
      // border: "none",
    },
    profileButton: {
      fontSize: 13,
      padding: "5px 0",
      textAlign: "center",
      display: "block",
      transition: theme.transitions.create("background-color", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    // buttonMyAccount: {
    //   // textShadow: '1px 1px 1px #333',
    //   fontWeight: "bold",
    //   textTransform: "lowercase",
    //   paddingLeft: 20,
    //   backgroundColor: "transparent",
    //   color: "#fff",
    //   backgroundImage: "none",
    //   border: "1px #fff solid",
    // },
    headerMenu: {
      textAlign: "right",
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
      },
      "& .MuiButton-root": {
        lineHeight: "1.75rem",
        minWidth: "auto",
        // display: "block",
        // color: theme.palette.primary.main, // Some CSS
        backgroundColor: "transparent",
        // border: "1px " + theme.palette.primary.main + " solid",
        // padding: "0 10px 0",
        // marginRight: 20,
        boxShadow: "none",
        position: "relative",
        "&:hover": {
          border: "none",
        },
      },
    },
    headerMenuButton: {
      // textShadow: '1px 1px 1px #333',
      margin: "0 0 10px auto",
      backgroundColor: "transparent",
      "&:hover": {
        border: "none",
        backgroundColor: "transparent",
      },
      maxWidth: 185,
      lineHeight: "1.75rem",
      minWidth: "auto",
      display: "block",
      color: theme.palette.primary.main, // Some CSS
      backgroundColor: "transparent",
      // border: "1px " + theme.palette.primary.main + " solid",
      border: "none",
      padding: "0 10px 0",
      // marginRight: 20,
      boxShadow: "none",
      position: "relative",
      transition: theme.transitions.create("border-radius", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      borderRadius: "4px 0 0 4px",

      [theme.breakpoints.down("sm")]: {
        display: "inline-block",
        // marginTop: 10,
        marginRight: 10,
        marginLeft: 10,
        marginBottom: 10,
      },
      "& .MuiButton-label": {
        padding: 0,
        position: "relative",
        zIndex: 10,
        "&:before": {
          content: "' '",
          position: "absolute",
          right: -20,
          width: 5,
          height: "100%",
          backgroundColor: theme.palette.primary.main,
        },
      },
      "&:after": {
        content: '" "',
        position: "absolute",
        bottom: 0,
        left: 0,
        backgroundColor: theme.palette.primary.main,
        width: 0,
        height: "100%",
        zIndex: 9,
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      "&:hover": {
        color: "#fff",
        "&:after": {
          width: "100%",
        },
      },
    },
    headerMenuButtonAccount: {
      marginRight: -10,
      backgroundColor: theme.palette.primary.main + " !important",
      color: "#fff",
      maxWidth: 200,
      overflow: "hidden",
      "& .MuiButton-label": {
        padding: 0,
        position: "relative",
        zIndex: 10,
        "&:before": {
          content: "' '",
          position: "absolute",
          right: -20,
          width: 5,
          height: "100%",
          backgroundColor: theme.palette.primary.main,
        },
      },
      "&:after": {
        color: theme.palette.primary.main,
        backgroundColor: "#fff",
      },
      "&:hover": {
        "& .MuiButton-label": {
          color: theme.palette.primary.main,
        },
      },
    },
    headerMenuButtonOpened: {
      borderRadius: "4px 4px 0 0",
    },
    headerMenuButtonSelected: {
      backgroundColor: theme.palette.primary.green + " !important",
      color: "#fff",
      "& .MuiButton-label": {
        "&:before": {
          backgroundColor: theme.palette.primary.green + " !important",
        },
      },
    },

    bgSpacerTop: {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      backgroundSize: "cover",
      height: 220,
      backgroundImage:
        "url(" +
        require("assets/images/" +
          process.env.REACT_APP_SITE +
          "/halfcircle_top.png") +
        ")",
      // marginBottom: theme.spacing(10),
      [theme.breakpoints.down("sm")]: {
        height: 70,
        marginBottom: theme.spacing(3),
      },
    },
    headerContent: {
      // marginTop: -50,
      width: "100%",
      marginTop: theme.spacing(15),
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        marginTop: 20,
      },
    },
  };
};
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isLogginIn: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this._gotoHome = this._gotoHome.bind(this);
    this._setIsLogginIn = this._setIsLogginIn.bind(this);
    this._onFormComplete = this._onFormComplete.bind(this);
  }

  _gotoHome() {
    this.props.history.push("/");
  }

  handleToggle = (e, url) => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleClose = (event, url) => {
    this.setState({ isLogginIn: false });

    if (this.$anchorEl.contains(event.target)) {
      return;
    }

    const { history } = this.props;
    this.setState({ open: false }, function () {
      // console.log('k', url)
      history.push(url);
    });
  };
  _setIsLogginIn = () => {
    this.setState({ isLogginIn: true });
  };
  _onFormComplete = () => {
    const { onLoggedIn } = this.props;
    this.setState({ isLogginIn: false }, () => {
      onLoggedIn();
    });
  };
  render() {
    const {
      // onPanelToggle,
      // userRole,
      current,
      headerImage,
      headerTitle,
      headerContent,
      isLoggedIn,
      condensed,
      $$user,
      classes,
      headerStyle,
      headerClass,
      // userSubRole
      // onRegistrationComplete,
    } = this.props;

    const { open, isLogginIn } = this.state;
    // console.log({isLogginIn})
    const menuSize = ["sm", "xs"].indexOf(this.props.width) < 0 ? 40 : 28;

    let headerType;
    if (headerImage) headerType = headerImage;
    else headerType = current ? current : undefined;

    let finalHeaderStyle = {};
    if (headerType !== undefined && headerType !== false)
      if (headerStyle !== undefined)
        // finalHeaderStyle.backgroundImage = 'url('+require('assets/images/header_'+headerType+'.jpg')+')';
        finalHeaderStyle = { ...finalHeaderStyle, ...headerStyle };

    const $$menu = config.getMenu($$user, { asImmutable: true });

    const $$profileMenu = config.getProfileMenu($$user, { asImmutable: true });

    const userRole = $$user !== undefined ? $$user.get("role") : undefined;
    const userSubRole =
      $$user !== undefined ? $$user.get("subRole") : undefined;
    // const logoMargin = ['sm', 'xs'].indexOf(this.props.width) < 0 ? '0 0 0 auto' : '30px auto 10px';
    // console.log({isLogginIn, userRole, userSubRole, $$user})
    return (
      <div className={classes.root}>
        <RGPDBanner key="rpgd" />
        <header
          key="header"
          id="header"
          className={clsx(classes.header, headerClass)}
          style={finalHeaderStyle}
        >
          <Grid
            container
            spacing={0}
            align="flex-end"
            className={classes.wrapper}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={7}
              lg={9}
              container
              alignContent="center"
            >
              <If condition={headerTitle !== undefined}>
                <Grid item xs={12}>
                  <span className="headerTitle">
                    <Typography variant="h1">{headerTitle}</Typography>
                  </span>
                </Grid>
              </If>
              <If condition={headerContent !== undefined}>
                <div className={classes.headerContent}>{headerContent}</div>
              </If>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={5}
              lg={3}
              className={classes.headerMenu}
            >
              <div
                className={classes.logo}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push("/?r=true");
                }}
              ></div>
              <HeaderMenu
                menuSize={menuSize}
                style={{ whiteSpace: "nowrap" }}
                current={current}
                userRole={userRole}
                isLoggedIn={isLoggedIn}
                $$menu={$$menu}
                itemClass={classes.headerMenuButton}
                itemClassSelected={classes.headerMenuButtonSelected}
              />
              <If condition={!isLoggedIn || isLogginIn}>
                <DialogPopinButton
                  trigger={Button}
                  triggerProps={{
                    className: clsx(
                      classes.headerMenuButton,
                      classes.headerMenuButtonAccount
                    ),
                    label: "Mon Compte",
                    children: "Mon Compte",
                  }}
                  showOnClose={true}
                  onOpened={this._setIsLogginIn}
                  popinTitle={"Connexion"}
                  popinContent={RegistrationForm}
                  popinContentProps={{
                    onFormComplete: this._onFormComplete,
                    closeOnComplete: true,
                    showRecap: true,
                  }}
                  openOnMount={false}
                />
              </If>
              <If
                condition={
                  isLogginIn !== true &&
                  (userRole === "member" ||
                    userRole === "admin" ||
                    userRole === "speaker" ||
                    userRole === "staff")
                }
              >
                <Button
                  onClick={this.handleToggle}
                  ref={(r) => {
                    this.$anchorEl = r;
                  }}
                  aria-owns={open ? "menu-list-grow" : undefined}
                  aria-haspopup="true"
                  className={clsx(
                    classes.headerMenuButton,
                    classes.headerMenuButtonAccount,
                    {
                      [classes.headerMenuButtonOpened]: open,
                    }
                  )}
                >
                  {$$user.get("email")}
                </Button>
                <Popper
                  open={open}
                  anchorEl={this.$anchorEl}
                  transition
                  disablePortal
                  style={{ zIndex: 999 }}
                  placement={"bottom"}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps} id="menu-list-grow">
                      <Paper classes={{ root: classes.profileWrapper }}>
                        <ClickAwayListener onClickAway={this.handleClose}>
                          <div>
                            <MenuList>
                              {$$profileMenu
                                .map((p, pIdx) => {
                                  if (p.get("target") === "_blank") {
                                    return (
                                      <MenuItem
                                        key={"pm_" + pIdx}
                                        onClick={(e) => {
                                          window.open(p.get("url"));
                                        }}
                                        classes={{
                                          root: classes.profileButton,
                                        }}
                                      >
                                        {p.get("title")}
                                      </MenuItem>
                                    );
                                  } else {
                                    return (
                                      <MenuItem
                                        key={"pm_" + pIdx}
                                        onClick={(e) => {
                                          this.handleClose(e, p.get("url"));
                                        }}
                                        classes={{
                                          root: classes.profileButton,
                                        }}
                                      >
                                        {p.get("title")}
                                      </MenuItem>
                                    );
                                  }
                                })
                                .toArray()}
                            </MenuList>
                          </div>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </If>
            </Grid>
          </Grid>
        </header>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    isLoggedIn: isLoggedIn(state),
    // userRole: getCurrentUserRole(state),
    // userSubRole: getCurrentUserSubRole(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onLoggedIn: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Header))
);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx